<template>
  <div class="container contentBox bgfff mt20">
    <div class="flex between ml10 mr10">
      <div class="flex center-row">

        <div class="flex center-row">
          <div class=" flex center-row">
            <span class="fz14 c6">{{ $t('alarmSetting.airModelQuire') }} ：</span>
            <!-- <el-input v-model="monitorId" placeholder="请输入空调编号"  style="width:160px"></el-input>      -->
            <el-select v-model="devModel" filterable clearable :placeholder="$t('dataAnalysis.pleCho')">
              <el-option v-for="(item, index) in typeList3" :key="index" :label="item.dictValue" :value="item.dictKey">
              </el-option>
            </el-select>
          </div>
          <el-button type="primary" size="small" class="ml10" icon="el-icon-search"
            @click="search()">{{ $t('tagsView.search') }}</el-button>
          <el-button type="primary" size="small" class="ml10" icon="el-icon-refresh"
            @click="refresh()">{{ $t('dataAnalysis.reset') }}</el-button>
        </div>
      </div>
      <el-button type="primary" size="small" v-if="permission.sys_alarm_add"
        @click="add()">{{ $t('alarmSetting.addAlarm') }}</el-button>
    </div>
    <div class="mt10 ml10 mr10 maxHeight">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column :prop="item.prop" :key='index' align="center" :width="item.width" :label="item.label"
          v-for="(item, index) in column">

        </el-table-column>
        <el-table-column prop="alarmLevelName" align="center" :label="$t('alarmSetting.triggerCondition')">
          <template slot-scope="scope">
            {{ scope.row.alarmTypeName + scope.row.threshold }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('realdetile.opera')" width="200" align="center">
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-view" v-if="permission.sys_alarm_edit"
              @click="viewHandle(scope.row)">{{ $t('alarmSetting.edit') }}</el-button>
            <el-button type="text" icon="el-icon-view" v-if="permission.sys_alarm_del"
              @click="delHandle(scope.row)">{{ $t('alarmSetting.delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="txtr mt20">
        <el-pagination background :current-page.sync="current" @current-change="handleCurrentChange" :page-size='size'
          layout="total, prev, pager, next" :total="total"></el-pagination>
      </div>
    </div>
    <el-dialog class="userForm" :title="form.title" :visible.sync="form.dialogFormVisible" width="55%" center>
      <el-form id="custom-form" class="flex" :model="form.formItem" :rules="form.rules" ref="ruleForm"
        label-width="120px">
        <el-row>
          <el-col :span='11'>
            <el-form-item :label="$t('manipulation.airModel')" prop="devModel" :label-width="formLabelWidth1">
              <!-- <el-cascader
                                style="width:100%"
                                v-model="form.formItem.projectDeviceId"
                                :options="typeList4"
                                :props='props'
                                @change="changecas"
                               ></el-cascader> -->
              <el-select v-model="form.formItem.devModel" clearable :placeholder="$t('dataAnalysis.pleCho')">
                <el-option v-for="(item, index) in typeList3" :key="index" :label="item.dictValue" :value="item.dictKey">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span='11'>
            <el-form-item :label="$t('alarmSetting.alarmContacts')" prop="lockFlag" :label-width="formLabelWidth1">
              <el-select v-model="form.formItem.linkman" :placeholder="$t('dataAnalysis.pleCho')" style="width:100%">
                <el-option v-for="(item, index) in userlist" :key="index" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>

          </el-col>
          <el-col :span='11'>
            <el-form-item :label="$t('alarmSetting.alarmName')" prop="alarmName" :label-width="formLabelWidth1">
              <el-input v-model="form.formItem.alarmName" placeholder></el-input>
            </el-form-item>
          </el-col>
          <el-col :span='11'>
            <el-form-item :label="$t('dataAnalysis.pleCho')" prop="alarmRank" :label-width="formLabelWidth1">
              <el-select v-model="form.formItem.alarmRank" :placeholder="$t('dataAnalysis.pleCho')" style="width:100%">
                <el-option v-for="(item, index) in typeList1" :key="index" :label="item.dictValue" :value="item.dictKey">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span='11'>
            <el-form-item :label="$t('alarmSetting.alarmType')" prop="alarmType" :label-width="formLabelWidth1">
              <el-select v-model="form.formItem.alarmType" :placeholder="$t('dataAnalysis.pleCho')" style="width:100%">
                <el-option v-for="(item, index) in typeList2" :key="index" :label="item.dictValue" :value="item.dictKey">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span='11'>
            <el-form-item :label="$t('alarmSetting.assVariable')" prop="monitorId" :label-width="formLabelWidth1">
              <el-select v-model="form.formItem.monitorId" :placeholder="$t('dataAnalysis.pleCho')" style="width:100%">
                <el-option v-for="item in variateOptions" :key="item.streamId + 'b'" :label="item.monitorName"
                  :value="item.monitorId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span='11'>
            <el-form-item :label="$t('alarmSetting.alarmThreshold')" prop="threshold" :label-width="formLabelWidth1">
              <el-input v-model="form.formItem.threshold" placeholder></el-input>
            </el-form-item>
          </el-col>
          <el-col :span='11'>
            <el-form-item :label="$t('alarmSetting.alarmContent')" prop="alarmContent" :label-width="formLabelWidth1">
              <el-input v-model="form.formItem.alarmContent" placeholder></el-input>
            </el-form-item>
          </el-col>
          <el-col :span='11'>
            <el-form-item :label="$t('alarmSetting.copMethodChoose')" prop="solution" :label-width="formLabelWidth1">
              <el-input v-model="form.formItem.solution" placeholder></el-input>
            </el-form-item>
          </el-col>
          <el-col :span='11'>
            <el-form-item :label="$t('alarmSetting.alarm')" prop="isAlarm" :label-width="formLabelWidth1">
              <el-switch v-model="form.formItem.isAlarm" active-color="#409EFF" inactive-color="#bbb" active-value="1"
                inactive-value="0"></el-switch>
            </el-form-item>
          </el-col>
          <!-- <el-col :span='11'>
                       <el-form-item label="短信报警" prop="isSms">
                            <el-checkbox v-model="form.isSms" :true-label="1" :false-label="0"></el-checkbox>
                       </el-form-item>
                   </el-col> -->
          <el-col :span='11'>
            <el-form-item :label="$t('alarmSetting.webAlarm')" prop="isWeb" :label-width="formLabelWidth1">
              <el-checkbox v-model="form.isWeb" :true-label="1" :false-label="0"></el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-form-item label="数值" prop="threshold">
                    <el-radio-group v-model="form.formItem.threshold">
                        <el-radio label="0">0</el-radio>
                        <el-radio label="1">1</el-radio>
                    </el-radio-group>
                </el-form-item> -->
        <!-- <el-form-item label="报警间隔(秒)" prop="intervalTime">
                    <el-input v-model="form.formItem.intervalTime" placeholder></el-input>
                </el-form-item> -->


      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="button--cancel" @click="handleClose">{{ $t('manipulation.cancel') }}</el-button>
        <el-button type="primary" @click="handleSubmit">{{ $t('manipulation.sure') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';
import { addObj, editObj, deleteObj, getList, dictType, getAllContact, getMonitorList, getProjectAndDeviceList } from '@/api/deviceOverview/alarm';
import { dictList, user_list } from '@/api/deviceOverview/file';
export default {
  name: 'alarmSetting',
  data() {
    return {
      searchVal: '',
      formLabelWidth1: '160px',
      tableData: [],
      typeList: [],
      levelList: [],
      contactList: [],
      variateOptions: [],
      type: '',
      curObj: {},
      current: 1,
      size: 10,
      total: 0,
      searchVariateOptions: [],
      devModel: '',
      form: {
        title: this.$t('alarmSetting.addAlarm'),
        dialogFormVisible: false,
        isSms: 0,
        isWeb: 0,
        formItem: {
          alarmName: '',
          alarmLevel: '',
          alarmType: '',
          threshold: '',
          monitorId: '',
          alarmContent: '',
          solution: '',
          // intervalTime:'',
          lockFlag: false,

          linkman: '',
          alarmRank: '',
          isAlarm: '',
          devModel: ''

        },
        rules: Object.freeze({
          alarmName: [{ required: true, message: this.$t('alarmSetting.inputAlarmName'), trigger: 'blur' }],

          alarmType: [{ required: true, message: this.$t('alarmSetting.choAlarmType'), trigger: 'change' }],
          monitorId: [{ required: true, message: this.$t('alarmSetting.choAssVariable'), trigger: 'change' }],
          threshold: [{ required: true, message: this.$t('alarmSetting.inputAlarmValue'), trigger: 'blur' }],
          alarmContent: [{ required: true, message: this.$t('alarmSetting.inputAlarmContent'), trigger: 'blur' }],
          // intervalTime: [{ required: true, message: '请输入报警间隔时间', trigger: 'blur' }]
        })
      },
      column: [
        { prop: 'index', label: this.$t('realdetile.serNum'), width: 50 },

        { prop: 'devModelName', label: this.$t('manipulation.airModel') },
        { prop: 'alarmName', label: this.$t('alarmSetting.alarmName') },
        { prop: 'alarmRankName', label: this.$t('alarmSetting.alarmLevel') },
        { prop: 'monitorName', label: this.$t('alarmSetting.assMonitor') },
        { prop: 'alarmContent', label: this.$t('alarmSetting.alarmContent') },

      ],
      disabled: '',
      typeList2: [],
      typeList1: [],
      typeList3: [],
      typeList4: [],
      userlist: [],
      props: {
        value: 'id',
        label: 'name',
        children: 'deviceList'
      }
    };
  },
  created() {

    this.getdictList()
    this.getuserlist()
    this.queryMonitorList()
  },
  components: {

  },
  computed: {
    ...mapGetters(["stationObj", 'permission'])
  },
  methods: {

    getuserlist() {
      user_list().then(res => {
        if (res.data.code === 200) {
          this.userlist = res.data.data
        }
      })
    },

    getdictList() {
      // 空调
      // getProjectAndDeviceList().then(res=>{
      //     if(res.data.code===200){

      //         this.typeList4 = res.data.data
      //     }
      // })
      dictList({ code: "device_model" }).then(res => {
        if (res.data.code === 200) {
          this.typeList3 = res.data.data[0].children
        }
      })
      // 报警等级
      dictList({ code: "alarm_rank" }).then(res => {
        if (res.data.code === 200) {
          this.typeList1 = res.data.data[0].children
        }
      })
      // 报警类型
      dictList({ code: "alarm_type" }).then(res => {
        if (res.data.code === 200) {
          this.typeList2 = res.data.data[0].children
        }
      })
    },
    viewHandle(row1) {

      let row = JSON.parse(JSON.stringify(row1))


      this.curObj = row
      this.type = 'edit'
      this.form.title = this.$t('alarmSetting.editAlarm')
      this.form.dialogFormVisible = true
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }

      this.form.isSms = Number(row.isSms)
      this.form.isWeb = Number(row.isWeb)
      this.form.formItem = row
      this.form.formItem.monitorId = row.monitorId
    },
    handleCurrentChange(cur) {

      this.current = cur
      this.queryListPage()
    },

    search() {
      this.current = 1
      this.queryListPage()
    },
    refresh() {
      this.current = 1
      this.devModel = ''
      this.queryListPage()
    },
    handleChange() {

    },
    queryListPage() {
      getList({ current: this.current, size: this.size, devModel: this.devModel }).then(res => {
        if (res.data.code === 200) {
          res.data.data.records.map((item, index) => {
            item.index = index + 1
          })
          this.tableData = res.data.data.records;
          this.rendOptions(this.tableData)
          this.total = res.data.data.total
        } else {
          this.$message.error(res.data.msg);
          return;
        }
      })
    },
    rendOptions(data) {
      let ary = []
      data.map(item => {
        let obj = {}
        obj.monitorName = item.monitorName
        obj.monitorId = item.monitorId
        ary.push(obj)
      })
      this.searchVariateOptions = ary
    },
    add() {
      this.form.dialogFormVisible = true
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }

      this.resetFormItem()
      this.type = 'add'
      this.form.title = this.$t('alarmSetting.addAlarm')
    },


    queryMonitorList() {
      getMonitorList().then(res => {
        if (res.data.code === 200) {
          let resData = res.data.data
          let ary = []
          this.variateOptions = resData

        } else {
          this.$message.error(res.data.msg);
          return;
        }
      })
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {

          const { alarmName, alarmLevel, alarmType,
            threshold, monitorId,
            alarmContent,
            solution,
            intervalTime,
            linkman,
            isAlarm,
            alarmRank,

            devModel,

            contactId,
            lockFlag } = this.form.formItem;


          if (this.type == 'add') {
            addObj({ isAlarm, linkman, alarmRank, isSms: this.form.isSms, isWeb: this.form.isWeb, devModel, alarmName, alarmType, threshold, alarmContent, solution, monitorId: monitorId, lockFlag: lockFlag * 1 }).then(res => {
              if (res.data.code === 200) {
                this.$message.success(this.$t('alarmSetting.addSuc'));
                this.form.dialogFormVisible = false;
                this.resetFormItem()
                this.queryListPage();

              } else {
                this.$message.error(this.$t('alarmSetting.addFauRepeat'));
                return;
              }
            });
          } else if (this.type == 'edit') {
            editObj({ alarmId: this.curObj.alarmId, alarmName, isAlarm, linkman, alarmRank, isSms: this.form.isSms, isWeb: this.form.isWeb, devModel, alarmType, threshold, alarmContent, solution, intervalTime, monitorId: monitorId, lockFlag: lockFlag * 1 }).then(res => {
              if (res.data.code === 200) {
                this.$message.success(this.$t('alarmSetting.chaSuc'));
                this.resetFormItem()
                this.form.dialogFormVisible = false;
                this.queryListPage();
              } else {
                this.$message.error(this.$t('alarmSetting.chaFauRepeat'));
                return;
              }
            });
          }
        } else {
          this.$message.warning(this.$t('alarmSetting.fillComplete'));
          return;
        }
      });
    },
    delHandle(row) {
      this.$confirm(this.$t('alarmSetting.promptContent') + '?', this.$t('alarmSetting.prompt'), {
        type: 'warning'
      })
        .then(() => {
          deleteObj({ id: row.alarmId }).then(res => {
            if (res.data.code === 200) {
              this.$message.success(this.$t('alarmSetting.deleteSuc'));
              this.current = 1;
              this.queryListPage();
            } else {
              this.$message.error(this.$t('alarmSetting.deleteFau'));
            }
          });
        })
        .catch(() => { });
    },
    handleClose() {
      this.form.dialogFormVisible = false;
    },
    resetFormItem() {
      this.form.isWeb = 0
      this.form.isSms = 0
      this.form.formItem = {
        alarmName: '',
        alarmLevel: '',
        alarmType: '',
        threshold: '',
        monitorId: '',
        alarmContent: '',
        solution: '',
        intervalTime: '',
        lockFlag: false
      }
    }
  },
  mounted() {
    this.queryListPage()
  }
};
</script>

<style lang="scss" scoped>
.contentBox {
  height: calc(100% - 40px);
  overflow-y: auto;
}

.handle-input {
  width: 200px;
}
</style>
